<template>
  <div class="bg-gray py-2 px-1 board-radius--4px">
    <div v-for="(detail, idx) in details" :key="idx">
      <div
        :class="`row mx-1 ${bgWhite ? 'p-2 bg-white board-radius--4px' : ''}`"
      >
        <div
          v-for="item in detail"
          :key="item.label"
          :class="`${item.cols ? item.cols : 'col-sm w-50'}`"
        >
          <div class="d-flex">
            <em
              v-if="item.icon"
              :class="item.icon"
              class="pt-1 mr-2 text-orange"
            />
            <div>
              <span class="body-2 text-gray">{{ item.label }}</span>
              <p class="body-1 font-weight-normal">
                {{ item.data }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Board',
  props: {
    details: {
      type: Array,
      required: true,
    },
    bgWhite: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>

<style>
.board-radius--4px {
  border-radius: 4px;
}
</style>
